import {WwsUmsatzstatistikOptionenListStore} from './abstractions/optionen-list.store';

export const WwsUmsatzstatistikVkforgStore = new WwsUmsatzstatistikOptionenListStore<{ id: number; vkforg: string; idekorg: number }>()
